import '../css/filter.css'
import React, { Component } from 'react'
import { Icon, Select, Dropdown, Responsive, Menu, Radio, Search } from 'semantic-ui-react'
import SearchPlaces from './SearchPlaces'
import DistanceRadio from './DistanceRadio'


const CategoryButton = (props, item, index) => (
	<Menu.Item
		key={index}
		onClick={() => props.onCategoryFilter(item)}
		active={item === props.state.currentCategory}>
		{item}
	</Menu.Item>
)

export default class Filter extends Component {

	render() {

		const btns = this.props.state.categories.map((item, index) => CategoryButton(this.props, item, index));

		var currentTypologies = [];
		this.props.state.data.forEach((item, index) => {
			// filter only typologies present in the current data
			if (item.category != this.props.state.currentCategory) return;
			if (currentTypologies.indexOf(item.typology) == -1) {
				currentTypologies.push(item.typology)
			}
		});

		const typologies = currentTypologies.map(item => {
			return {
				name: item.name,
				icon: item.icon.replace("fa-", "").replace("-", " "),
				onChange: () => this.props.onTypologyFilter(item.name)
			}
		});

		typologies.unshift({
			name: "Ver todos",
			onChange: () => this.props.onTypologyFilter(null)
		});


		let ct = this.props.state.currentTypology;
		let selectOptions = typologies.map((item, index) => {

			return {
				text: item.name,
				value: item.name,
				icon: item.icon || null,
				onClick: item.onChange,
				active: ct ? item.name == ct : item.name === "Ver todos"
			}

		});

		

		return (
			<div>

				<Menu tabular>
					{btns}
					<Menu.Menu position='right'>
						<Responsive minWidth={1000}>
							<Menu.Item>
								<SearchPlaces
									id="searchbar"
									data={this.props.state.currentData}
								/>
							</Menu.Item>
						</Responsive>
					</Menu.Menu>
				</Menu>

				<div id="filter">
					{/* <p>Mostra:</p> */}

					<div id="filter-options">
						<Responsive minWidth={768}>
							<Menu secondary>
								{
									typologies.map(item => (
										<Menu.Item key={item.name} onClick={item.onChange} name={item.name} active={ct ? item.name == ct : item.name === "Ver todos"}>
											{item.icon && <Icon name={item.icon} />}
											{item.name}
										</Menu.Item>
									))
								}
							</Menu>

						</Responsive>


						<Responsive maxWidth={767}>
							<Dropdown fluid selection value={selectOptions.find(d => d.active).text} options={selectOptions} />
						</Responsive>



					</div>

					<Responsive minWidth={768}>
						<DistanceRadio onSortByDistance={this.props.onSortByDistance} />
					</Responsive>
				</div>


			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/itemslist/FilterBtn.js